export function getCsrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
}

// A long-lived (vue-turbolinks) component caches its rendered authenticity_token field, but Turbo rotates the
// csrf-token meta tag across navigations. Refresh the field from the live meta tag right before submit so the
// token sent with the form is never stale.
export function setFormCsrfToken(container: ParentNode): void {
  const token = getCsrfToken()
  const input = container.querySelector<HTMLInputElement>('input[name="authenticity_token"]')
  if (token && input) {
    input.value = token
  }
}
